"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var config_1 = __importDefault(require("config"));
var use_stores_1 = require("hooks/use-stores");
var help_icon_svg_1 = __importDefault(require("res/img/help-icon.svg"));
var close_icon_svg_1 = __importDefault(require("../../../../res/img/close-icon.svg"));
var Dialog_1 = require("../../../Dialog");
var Notification_1 = require("../../../Notification");
var use_notification_1 = require("../../../../hooks/use-notification");
var use_dialog_1 = require("../../../../hooks/use-dialog");
var Select_1 = __importDefault(require("../../../common/inputs/Select"));
var apiRoutes = config_1.default.apiRoutes;
var EditRelatedProducts = mobx_react_1.observer(function (_a) {
    var product = _a.product, products = _a.products;
    var _b = react_1.useState([]), relatedProducts = _b[0], setRelatedProducts = _b[1];
    var _c = react_1.useState(null), selectedOption = _c[0], setSelectedOption = _c[1];
    var params = react_router_dom_1.useParams();
    var apiStore = use_stores_1.useStores().apiStore;
    var busyRoutes = apiStore.data.busyRoutes;
    var notification = use_notification_1.useNotification();
    var dialog = use_dialog_1.useDialog();
    var sortedProducts = products.sort(function (a, b) { return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }); });
    react_1.useEffect(function () {
        if (!busyRoutes.includes(apiRoutes.PRODUCTS + apiRoutes.RELATED_PRODUCTS)) {
            api_1.default.getRelatedProducts(product.id)
                .then(function (response) { return setRelatedProducts(response.data); })
                .catch(api_1.catchHandler);
        }
    }, [params.id]);
    var deleteHandler = function (related) {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: 'Delete Related Product',
            description: 'Are you sure you want to delete this related product?'
        })
            .then(function () {
            api_1.default.deleteRelatedProduct(related)
                .then(function () {
                api_1.default.getRelatedProducts(product.id)
                    .then(function (response) { return setRelatedProducts(response.data); })
                    .catch(api_1.catchHandler);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: 'Related Product has been deleted'
                });
            })
                .catch(api_1.catchHandler);
        });
    };
    var changeHandler = function (value) {
        setSelectedOption(value);
        console.log(value);
    };
    var addHandler = function () {
        selectedOption !== null ?
            api_1.default.addRelatedProduct(product.id, selectedOption)
                .then(function () {
                api_1.default.getRelatedProducts(product.id)
                    .then(function (response) { return setRelatedProducts(response.data); })
                    .catch(api_1.catchHandler);
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: 'Related Product has been added'
                });
            })
                .catch(api_1.catchHandler) : null;
    };
    return (react_1.default.createElement("div", { className: 'edit-product__page edit-product-reviews' },
        react_1.default.createElement("span", { className: 'title' }, "Related Products"),
        react_1.default.createElement("div", { className: 'help flex flex-row' },
            react_1.default.createElement("img", { src: help_icon_svg_1.default, alt: 'Help' }),
            react_1.default.createElement("p", null, "Add related products to this item")),
        react_1.default.createElement("div", { className: 'edit-product-reviews__list' },
            react_1.default.createElement("div", { className: 'standard-select' },
                react_1.default.createElement("label", { className: 'standard-select-label' }, "Select Related Product: "),
                react_1.default.createElement(Select_1.default, { value: selectedOption, onChange: changeHandler, options: sortedProducts.map(function (otherProduct, i) { return (otherProduct.id !== product.id ?
                        {
                            value: otherProduct.id,
                            text: otherProduct.name
                        } : null); }) }),
                react_1.default.createElement("button", { className: "button standard-select-button", type: "button", "aria-label": "Add Related Product", onClick: function () { return addHandler(); }, title: "Add Related Product" }, "Add Related Product")),
            react_1.default.createElement("div", { className: 'related-products' },
                react_1.default.createElement("span", { className: 'subtitle' }, "Current Related Products"),
                relatedProducts.map(function (related) { return (react_1.default.createElement("div", { className: 'related-product' },
                    react_1.default.createElement("button", { type: 'button', "aria-label": 'Delete Related Product', onClick: function () { return deleteHandler(related); }, className: '', title: 'Delete Related Product' },
                        react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Delete' })),
                    react_1.default.createElement("span", { className: "related-label", key: related.id },
                        " - ",
                        related.relatedProduct.name))); })))));
});
exports.default = EditRelatedProducts;
